// removed by extract-text-webpack-plugin
module.exports = {"grid-tooltip-list":"grid-tooltip-list","gridTooltipList":"grid-tooltip-list"};


//////////////////
// WEBPACK FOOTER
// ./src/components/portal/gridTooltip/styles.scss
// module id = 1492
// module chunks = 0